// eslint-disable-next-line import/no-anonymous-default-export
export default {
    LOGO: '',
    FAVICON: '',
    APP_NAME: 'UResolve',
    SERVER_URL: 'https://api.u-resolve.com/',
    BASE_URL: 'https://api.u-resolve.com/v1',
    // SERVER_URL: 'http://localhost:3315/',
    // BASE_URL: 'http://localhost:3315/api/v1',
    RESOLUTION_AMOUNT: 15000,
}